module.exports = __webpack_public_path__ + "static/media/coface_logo.38167be8.jpg";